import React from 'react';
import { ProductImage } from '../productContent/productImage';
import { ProductName } from '../productContent/productName';
import { ProductAvailability } from '../productContent/productAvailability';
import { ItemIdentifier, ItemIndicator } from '../../constants/productObjects';
import { CartItemDropdownList } from '../cartItemDropdownList/cartItemDropdownList';
import { PurchaseProcess, SupercedeDisplayCondition } from '../../constants/enums';
import { Button } from "wbm-inputs";
import { WBMFormatMoney } from "wbm-format-money";

type ProductAvailabilityType = {
    alertLevel: number,
    calloutMessage: string,
    deliveryMessage: string,
    estimatedDeliveryDate: string,
    estimatedDeliveryDateEndRange: string,
    itemId: string,
    requiresMessageDescriptions: boolean,
    stockMessage: string,
    unitId: string,
    wbTruckDelivery: boolean
}

export interface CartItemProps {
    qty: number,
    isMobile: boolean,
    imgUrl: string,
    altText: string,
    brandName: string,
    itemId?: string,
    description: string,
    itemIdentifier: ItemIdentifier,
    itemIndicators: ItemIndicator[],
    listPrice: number,
    unitPrice: number,
    unitId: string,
    discount: number,
    availabilityInfo: ProductAvailabilityType[],
    smallText: boolean,
    isCartItemDropdown: boolean,
    cartItemDropdownProps: object,
    sellPrice?: number,
    supercedePopup?: boolean,
    purchaseProcess?: number,
    customizedUrl?: string,
    removeMultiSelect?: () => void,
    displayListPrice?: boolean,
    displayLowerOriginalPrice?: number,
    imageNotLoaded?: boolean
    hostUrl?: string;
}

export const CartItem = (props: CartItemProps) => {

    let customizeUrl
    if (props.customizedUrl) {
        customizeUrl = props.customizedUrl;
    }

    const sellPrice = <WBMFormatMoney amount={props.sellPrice || 0} useCurrencySign />
    const unitPrice = <WBMFormatMoney amount={props.unitPrice || 0} useCurrencySign />
    const listPrice = <WBMFormatMoney amount={props.listPrice || 0} useCurrencySign />

    return (
        <div className={`cart-item-wrapper ${props.isMobile ? 'mobile-view' : ''}`}>
            <div className='cart-item-object'>
                {props.imageNotLoaded ?
                    <div style={{ width: '90px', height: '90px' }} className='skeleton'></div> :
                    <ProductImage imgUrl={props.imgUrl}
                        altText={props.altText}
                        width={72} height={72} />
                }
                <div className='cart-item-right'>
                    <div className='productname-price'>
                        <div className="product-name">
                            <ProductName brandName={props.brandName}
                                description={props.description}
                                qty={props.qty}
                                textBold={true}
                                displayId={props.itemId ? props.itemId : ''}
                                itemIdentifier={props.itemIdentifier}
                                itemIndicators={props.itemIndicators} />
                        </div>
                        <div className="product-pricing">
                            {props.sellPrice && props.supercedePopup ? props.displayLowerOriginalPrice !== SupercedeDisplayCondition.Never &&
                                <div className="sale-price">
                                    {sellPrice} /{props.unitId}
                                </div>
                                : <>
                                    <div>
                                        <span className="unit-price">{props.unitPrice ? unitPrice : ''}</span>
                                        <span className="unit-id">/{props.unitId}</span>
                                    </div>
                                    {props.displayListPrice ?
                                        <div>
                                            <span className="list-price">{props.listPrice ? listPrice : ""}</span>
                                            <span className="unit-id">/{props.unitId}</span>
                                        </div>
                                        : <></>}
                                </>
                            }
                            {props.purchaseProcess === PurchaseProcess.NavInk ?
                                <div className="customize-button">
                                    <a href={customizeUrl}>
                                        Customize
                                    </a>
                                </div> :
                                <> </>
                            }
                            {props.removeMultiSelect &&
                                <Button className="wbm-button btn btn-link medium" onClick={() => props.removeMultiSelect ? props.removeMultiSelect() : ''}>
                                    Remove
                                </Button>
                            }
                        </div>

                    </div>
                    {props.availabilityInfo ?
                        <div className='product-availability'> <ProductAvailability
                            availabilityInfo={props.availabilityInfo}
                            smallText={props.smallText}
                            hostUrl={props.hostUrl}
                        />
                        </div> :
                        <></>
                    }
                    {(props.availabilityInfo && props.availabilityInfo.doPreventAddToCart == true) ?
                        <div className="product-not-availabile">
                            <div>It cannot be added to your cart.</div>
                        </div> :
                        <></>
                    }
                    {props.purchaseProcess === PurchaseProcess.NavInk ?
                        <div className="customize-warning">
                            This item must be customized before adding to cart.
                        </div> :
                        <> </>
                    }
                </div>
            </div>
            {props.isCartItemDropdown && <CartItemDropdownList {...props.cartItemDropdownProps} />}
        </div>)
};